import React, { useEffect, useRef } from 'react';
import { ReactComponent as TickIcon } from '../../../assets/icons/tick.svg';
import '../../../Components/Common/typography.css';
import { DirectorSortBy } from '../../../utils/type';

export interface SortOption {
  label: string;
  value: DirectorSortBy;
}

interface SortDropdownProps {
  isOpen: boolean;
  currentSortBy: DirectorSortBy;
  options: SortOption[];
  onSelect: (sortBy: DirectorSortBy) => void;
  onClose: () => void;
}

const SortDropdown: React.FC<SortDropdownProps> = ({
  isOpen,
  currentSortBy,
  options,
  onSelect,
  onClose,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="director-sort-dropdown" ref={ref}>
      <div className="director-sort-dropdown-header body-s-regular">
        Sort by
      </div>
      {options.map((option) => (
        <div
          key={option.value}
          className={`director-sort-dropdown-item body-s-regular${currentSortBy === option.value ? ' director-sort-dropdown-item--active' : ''}`}
          onClick={(e) => {
            e.stopPropagation();
            onSelect(option.value);
            onClose();
          }}
        >
          <span>{option.label}</span>
          {currentSortBy === option.value && (
            <TickIcon className="director-sort-dropdown-tick" />
          )}
        </div>
      ))}
    </div>
  );
};

export default SortDropdown;
